document.addEventListener('DOMContentLoaded', function () {
  const menuLinks = document.querySelectorAll('.header-menu-list');
  const overlay = document.querySelector('.menu-overlay');
  const body = document.body;

  // 🔹 When clicking a header menu link
  menuLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const parentItem = this.closest('.list-menu-item');
      const dropdown = parentItem.querySelector('.dropdown-menu');

      // Close any other open drawers
      document.querySelectorAll('.dropdown-menu.open').forEach(openMenu => {
        if (openMenu !== dropdown) openMenu.classList.remove('open');
      });

      // Toggle current drawer
      const isOpen = dropdown.classList.toggle('open');

      // Handle overlay + body state
      if (isOpen) {
        overlay.classList.add('active');
        body.classList.add('drawer-open');
      } else {
        overlay.classList.remove('active');
        body.classList.remove('drawer-open');
      }
    });
  });

  // 🔹 Close all when clicking overlay
  overlay.addEventListener('click', () => {
    document.querySelectorAll('.dropdown-menu.open').forEach(menu => menu.classList.remove('open'));
    overlay.classList.remove('active');
    body.classList.remove('drawer-open');
  });

  // 🔹 Close all when clicking .menu-close-header button
    document.addEventListener('click', e => {
        const closeBtn = e.target.closest('.menu-close-header');
        if (closeBtn) {
            document.querySelectorAll('.dropdown-menu.open').forEach(menu => menu.classList.remove('open'));
            overlay.classList.remove('active');
            body.classList.remove('drawer-open');
        }
    });
    
  const mobileMenuIcon = document.querySelector('.main-mobile-icon-menu');
  const mobileMenu = document.querySelector('.mobile-megamenu');

  if (mobileMenuIcon && mobileMenu && overlay) {
    mobileMenuIcon.addEventListener('click', function () {
      mobileMenu.classList.add('open');
      overlay.classList.add('active');
      body.classList.add('drawer-open');
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      mobileMenu.classList.remove('open');
      overlay.classList.remove('active');
      body.classList.remove('drawer-open');
    });
  }

  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.menu-close-header');
    if (closeBtn) {
      mobileMenu.classList.remove('open');
      overlay.classList.remove('active');
      body.classList.remove('drawer-open');
    }

    const backSection = e.target.closest('.back-section');
    if (backSection) {
      const dropdownMenu = backSection.closest('.dropdown-menu');
      if (dropdownMenu) {
        dropdownMenu.classList.remove('open');
      }
    }
  });

  const rightMenuLinks = document.querySelectorAll('.right-menu .menu-link');
  const dropdown = document.querySelector('.right-menu .dropdown-menu');

  // 🔹 When clicking a right-menu link
  rightMenuLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const isOpen = dropdown.classList.toggle('open');

      if (isOpen) {
        overlay.classList.add('active');
        body.classList.add('drawer-open');
      } else {
        overlay.classList.remove('active');
        body.classList.remove('drawer-open');
      }
    });
  });

  // 🔹 Close all when clicking overlay
  overlay.addEventListener('click', () => {
    dropdown.classList.remove('open');
    overlay.classList.remove('active');
    body.classList.remove('drawer-open');
  });

  // 🔹 Close all when clicking .menu-close-header button
  document.addEventListener('click', e => {
    const closeBtn = e.target.closest('.menu-close-header');
    if (closeBtn) {
      dropdown.classList.remove('open');
      overlay.classList.remove('active');
      body.classList.remove('drawer-open');
    }
  });


  const searchInput = document.querySelector('.mobile-search-input');
  const resultsContainer = document.querySelector('.mobile-search-result-list-wrapper');
  const drawer = document.querySelector('.mobile-search-drawer-main');

  if (!searchInput || !resultsContainer || !drawer) return;

  let debounceTimer;

  // Simple SVG placeholder (when product/collection/article has no image)
  const placeholderSVG = `
    <svg width="100" height="100" viewBox="0 0 100 100">
      <rect width="100" height="100" fill="#eee" />
      <text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" fill="#aaa" font-size="12">No Image</text>
    </svg>
  `;

  // Handle input
  searchInput.addEventListener('input', function () {
    const query = this.value.trim();

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (!query) {
        // Hide drawer and clear results when input is empty
        drawer.classList.remove('active');
        resultsContainer.innerHTML = '';
        return;
      }

      // Show drawer when typing starts
      drawer.classList.add('active');
      resultsContainer.innerHTML = '<p class="paragraph-medium loading">Searching...</p>';

      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article&resources[limit]=25`)
        .then(res => res.json())
        .then(data => {
          const { products = [], collections = [], articles = [] } = data.resources.results;
          let html = '';

          // 🔹 Products
          if (products.length) {
            html += `<ul class="product-grid">`;
            products.forEach(p => {
              const img = p.image ? `<img src="${p.image}" alt="${p.title}">` : placeholderSVG;
              html += `
                <li class="grid-item">
                  <a href="${p.url}">
                    <div class="product-grid-item">
                      ${img}
                      <span class="product-title">${p.title}</span>
                    </div>
                  </a>
                </li>`;
            });
            html += `</ul></div>`;
          }

          // 🔹 Collections
          if (collections.length) {
            html += `<ul class="collection-grid">`;
            collections.forEach(c => {
              const img = c.image ? `<img src="${c.image}" alt="${c.title}">` : placeholderSVG;
              html += `
                <li class="collection-item">
                  <a href="${c.url}">
                    ${img}
                    <span class="collection-title">${c.title}</span>
                  </a>
                </li>`;
            });
            html += `</ul></div>`;
          }

          // 🔹 Articles
          if (articles.length) {
            html += `<ul class="article-grid">`;
            articles.forEach(a => {
              const img = a.image ? `<img src="${a.image}" alt="${a.title}">` : placeholderSVG;
              html += `
                <li class="article-item">
                  <a href="${a.url}">
                    ${img}
                    <span class="article-title">${a.title}</span>
                  </a>
                </li>`;
            });
            html += `</ul></div>`;
          }

          // 🔹 No Results
          if (!products.length && !collections.length && !articles.length) {
            html = `<p class="no-results paragraph-medium">No results found for "<strong>${query}</strong>"</p>`;
          }

          resultsContainer.innerHTML = html;
        })
        .catch(err => {
          resultsContainer.innerHTML = `<p class="paragraph-medium">Error loading results.</p>`;
        });
    }, 300); // Debounce time (ms)
  });

  const firstMenu = document.querySelector('.drawer-main-menu');
  const firstSubmenu = firstMenu?.nextElementSibling;

  function handleSubmenu() {
    const isDesktop = window.innerWidth > 991;

    if (isDesktop) {
      // Open first submenu on desktop
      if (firstSubmenu && firstSubmenu.classList.contains('submenu')) {
        firstSubmenu.classList.add('show');
        firstMenu.classList.add('open-dropdown');
        firstMenu.querySelector('svg')?.classList.add('is-open');
        slideDown(firstSubmenu);
      }
    } else {
      // Close submenu on mobile
      if (firstSubmenu && firstSubmenu.classList.contains('submenu')) {
        firstSubmenu.classList.remove('show');
        firstMenu.classList.remove('open-dropdown');
        firstMenu.querySelector('svg')?.classList.remove('is-open');
        slideUp(firstSubmenu);
      }
    }
  }

  // Initial check
  handleSubmenu();

  // Handle resize events
  window.addEventListener('resize', handleSubmenu);


});

(function() {
  function initLinklistSlider(section) {
    const carousel = section.querySelector('.linklist-swiper');
    if (!carousel || carousel.classList.contains('swiper-initialized')) return;

    const slideCount = carousel.querySelectorAll('.swiper-slide').length;

    const swiperInstance = new Swiper(carousel, {
      slidesPerView: 2.22,
      spaceBetween: 2,
      loop: true,
      
      mousewheel: slideCount > 2 ? {
        enabled: true,
        releaseOnEdges: true,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
      } : false,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
      }
    });

    carousel.swiperInstance = swiperInstance;
  }

  function destroyLinklistSlider(section) {
    const carousel = section.querySelector('.linklist-swiper');
    if (carousel?.swiperInstance) {
      carousel.swiperInstance.destroy(true, true);
      carousel.swiperInstance = null;
    }
  }

  function setupLinklistSlider() {
    document.querySelectorAll('.bd-linklist-section').forEach(section => {
      const carousel = section.querySelector('.linklist-swiper');
      if (!carousel) return;

      const isEnabled = carousel.classList.contains('swiper-initialized');
      if (!isEnabled) {
        initLinklistSlider(section);
      }
    });
  }

  // DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupLinklistSlider);
  } else {
    setupLinklistSlider();
  }

  // Debounced resize
  var resizeRunning = false;

  window.addEventListener('resize', () => {
    if (resizeRunning) return;
    resizeRunning = true;

    requestAnimationFrame(() => {
      setupLinklistSlider();
      resizeRunning = false;
    });
  });

  // Shopify section lifecycle
  document.addEventListener('shopify:section:load', e => {
    const section = document.querySelector(`.bd-linklist-section[data-section-id="${e.detail.sectionId}"]`);
    // if (section) setTimeout(() => initLinklistSlider(section), 500);
    if (section) {
      const waitForDOM = () => {
        // Only init when section is actually painted and visible
        if (document.body.contains(section)) {
          requestAnimationFrame(() => initLinklistSlider(section));
        } else {
          requestAnimationFrame(waitForDOM);
        }
      };
      requestAnimationFrame(waitForDOM);
    }
  });

  document.addEventListener('shopify:section:unload', e => {
    const section = document.querySelector(`.bd-linklist-section[data-section-id="${e.detail.sectionId}"]`);
    if (section) destroyLinklistSlider(section);
  });

  document.addEventListener('shopify:theme-settings:updated', setupLinklistSlider);
})();


document.addEventListener('click', function (e) {
  const clicked = e.target.closest('.dropdown-menu-link');
  if (!clicked) return;

  const submenu = clicked.nextElementSibling;

  // If the clicked link has a submenu
  if (submenu && submenu.classList.contains('bd-linklist-section')) {
    e.preventDefault();

    const isOpen = submenu.classList.contains('show');

    // Close all open dropdowns first
    document.querySelectorAll('.bd-linklist-section.show').forEach(el => {
      slideUp(el);
      el.classList.remove('show');
    });
    document.querySelectorAll('.dropdown-menu-link').forEach(el => {
      el.classList.remove('open-dropdown');
      el.querySelector('svg')?.classList.remove('is-open');
    });

    // Toggle the clicked one
    if (!isOpen) {
      slideDown(submenu);
      submenu.classList.add('show');
      clicked.classList.add('open-dropdown');
      clicked.querySelector('svg')?.classList.add('is-open');
    }
  }
});



document.addEventListener('click', function (e) {
  const clicked = e.target.closest('.drawer-main-menu');
  if (!clicked) return;

  const submenu = clicked.nextElementSibling;

  // only act if the item actually has a submenu
  if (submenu && submenu.classList.contains('submenu')) {
    e.preventDefault();

    const isOpen = submenu.classList.contains('show');

    // Close all other dropdowns first
    document.querySelectorAll('.submenu.show').forEach(el => {
      slideUp(el);
      el.classList.remove('show');
    });
    document.querySelectorAll('.drawer-main-menu').forEach(el => {
      el.classList.remove('open-dropdown');
      el.querySelector('svg')?.classList.remove('is-open');
    });

    // Toggle clicked one
    if (!isOpen) {
      slideDown(submenu);
      submenu.classList.add('show');
      clicked.classList.add('open-dropdown');
      clicked.querySelector('svg')?.classList.add('is-open');
    }
  }
});



// --- Animation Functions ---
function slideUp(element, duration = 300) {
  element.style.height = element.offsetHeight + 'px';
  element.offsetHeight;
  element.style.transition = `height ${duration}ms ease`;
  element.style.overflow = 'hidden';
  element.style.height = 0;

  window.setTimeout(() => {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition');
  }, duration);
}

function slideDown(element, duration = 300) {
  element.style.removeProperty('display');
  let display = window.getComputedStyle(element).display;
  if (display === 'none') display = 'block';
  element.style.display = display;

  const height = element.offsetHeight;
  element.style.height = 0;
  element.style.overflow = 'hidden';
  element.style.transition = `height ${duration}ms ease`;
  element.offsetHeight;
  element.style.height = height + 'px';

  window.setTimeout(() => {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition');
  }, duration);
}


